"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _historyLogModule = _interopRequireDefault(require("./historyLog.module.css"));

var _horizontalRule = _interopRequireDefault(require("../horizontalRule/horizontalRule"));

var _themeModule = _interopRequireDefault(require("../../../styles/theme.module.css"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactTruncateMarkup = _interopRequireDefault(require("react-truncate-markup"));

var _html = _interopRequireDefault(require("react-lines-ellipsis/lib/html"));

var _sanitizeHtml = _interopRequireDefault(require("sanitize-html"));

var _link = _interopRequireDefault(require("../link/link"));

var _functions = require("../../../utils/functions");

var _heading = _interopRequireDefault(require("../heading/heading"));

var _reactI18next = require("react-i18next");

var _resourceKeys = require("../providers/translations/resources/resourceKeys");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var HistoryLog = function HistoryLog(props) {
  var id = props.id,
      createdBy = props.createdBy,
      createdDate = props.createdDate,
      subtitle = props.subtitle,
      title = props.title,
      log = props.log,
      leftColumnSize = props.leftColumnSize,
      rightColumnSize = props.rightColumnSize,
      attachments = props.attachments,
      attachmentTitle = props.attachmentTitle;
  var LEFT_COLUMN_SIZE = leftColumnSize ? leftColumnSize : "col-sm-3";
  var RIGHT_COLUMN_SIZE = rightColumnSize ? rightColumnSize : "col-sm-9";
  var COLUMN_SIZE_WRAP = "col-sm-12";

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isReadingMore = _useState2[0],
      setIsReadingMore = _useState2[1];

  var linesEllipsis = (0, _react.useRef)(null);

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      clamped = _useState4[0],
      setClamped = _useState4[1];

  var sanitizedContent = (0, _sanitizeHtml.default)(log);

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  (0, _react.useEffect)(function () {
    if (linesEllipsis.current && linesEllipsis.current.clamped) {
      setClamped(linesEllipsis.current.clamped);
    }
  }, [linesEllipsis.current]);
  return _react.default.createElement("div", {
    id: id ? id : null,
    className: (0, _classnames.default)(_themeModule.default.arag, _historyLogModule.default["form-group"])
  }, _react.default.createElement("div", {
    id: id ? "".concat(id, "_log_row") : null,
    className: _historyLogModule.default["row"]
  }, _react.default.createElement("div", {
    id: id ? "".concat(id, "_log_left_col") : null,
    className: LEFT_COLUMN_SIZE
  }, _react.default.createElement("div", {
    id: id ? "".concat(id, "_log_left_creator_row") : null,
    className: COLUMN_SIZE_WRAP
  }, _react.default.createElement("label", {
    id: id ? "".concat(id, "_log_left_creator_label") : null
  }, createdBy)), _react.default.createElement("div", {
    id: id ? "".concat(id, "_log_left_row_created_date") : null,
    className: COLUMN_SIZE_WRAP
  }, createdDate), _react.default.createElement("div", {
    id: id ? "".concat(id, "_log_left_row_sub_title") : null,
    className: COLUMN_SIZE_WRAP
  }, subtitle)), _react.default.createElement("div", {
    id: id ? "".concat(id, "_log_right_col") : null,
    className: RIGHT_COLUMN_SIZE
  }, _react.default.createElement("div", {
    id: id ? "".concat(id, "_log_right_title") : null,
    className: COLUMN_SIZE_WRAP
  }, _react.default.createElement("label", {
    id: id ? "".concat(id, "_log_right_title_label") : null
  }, title)), _react.default.createElement("div", {
    id: id ? "".concat(id, "_log_right_content_wrapper") : null,
    className: COLUMN_SIZE_WRAP
  }, isReadingMore ? _react.default.createElement("div", {
    id: id ? "".concat(id, "_log_right_content_collapsed") : null
  }, (0, _functions.isHTML)(sanitizedContent) ? _react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: sanitizedContent
    }
  }) : sanitizedContent, _react.default.createElement("div", {
    id: id ? "".concat(id, "_log_right_content_link_wrapper") : null
  }, _react.default.createElement(_link.default, {
    id: id ? "".concat(id, "_log_right_content_link") : null,
    expanded: isReadingMore,
    expandable: true,
    variant: "tertiary",
    arrowDirection: "left",
    label: isReadingMore ? t(_resourceKeys.resourceKeys.readLess.key) : t(_resourceKeys.resourceKeys.readMore.key),
    onClick: function onClick() {
      return setIsReadingMore(!isReadingMore);
    }
  }))) : (0, _functions.isHTML)(sanitizedContent) ? _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_html.default, {
    maxLine: "3",
    unsafeHTML: sanitizedContent,
    ref: linesEllipsis
  }), clamped && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_link.default, {
    id: id ? "".concat(id, "_log_right_content_link") : null,
    expanded: isReadingMore,
    expandable: true,
    variant: "tertiary",
    arrowDirection: "left",
    label: isReadingMore ? t(_resourceKeys.resourceKeys.readLess.key) : t(_resourceKeys.resourceKeys.readMore.key),
    onClick: function onClick() {
      return setIsReadingMore(!isReadingMore);
    }
  }))) : _react.default.createElement(_reactTruncateMarkup.default, {
    lines: 3,
    ellipsis: _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("span", {
      id: id ? "".concat(id, "_log_right_content_dots") : null
    }, " ..."), _react.default.createElement("br", null), _react.default.createElement(_link.default, {
      id: id ? "".concat(id, "_log_right_content_link") : null,
      expanded: isReadingMore,
      expandable: true,
      variant: "tertiary",
      arrowDirection: "left",
      label: isReadingMore ? t(_resourceKeys.resourceKeys.readLess.key) : t(_resourceKeys.resourceKeys.readMore.key),
      onClick: function onClick() {
        return setIsReadingMore(!isReadingMore);
      }
    }))
  }, _react.default.createElement("div", {
    id: id ? "".concat(id, "_log_right_content_truncated") : null
  }, log)), attachments && attachments.length && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_heading.default, {
    id: id ? "".concat(id, "_log_header") : null,
    title: attachmentTitle ? attachmentTitle : "Attachments",
    variant: "h4"
  }), _react.default.createElement("ul", {
    id: id ? "".concat(id, "_log_list") : null
  }, attachments.map(function (attachment, index) {
    return _react.default.createElement("li", {
      id: id ? "".concat(id, "_log_item") : null,
      className: "col-sm-12",
      key: index
    }, attachment.formatter ? attachment.formatter() : _react.default.createElement("span", {
      id: id ? "".concat(id, "_log_item_name") : null
    }, attachment.name), attachment.downloadFile ? attachment.downloadFile : _react.default.createElement(_link.default, {
      id: id ? "".concat(id, "_log_item_link") : null,
      variant: "tertiary",
      arrowDirection: "left",
      label: "Download",
      onClick: function onClick() {
        return (0, _functions.downLoadFile)(attachment.name, attachment.encodedFile);
      }
    }));
  })))))), _react.default.createElement("div", {
    id: id ? "".concat(id, "_log_hr_pale_wrapper") : null,
    className: COLUMN_SIZE_WRAP
  }, _react.default.createElement(_horizontalRule.default, {
    id: id ? "".concat(id, "_log_hr_pale") : null,
    variant: "pale"
  })));
};

HistoryLog.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,

  /** String text needs name and encodedFile to download the file*/
  attachments: _propTypes.default.arrayOf(_propTypes.default.shape({
    encodedFile: _propTypes.default.string,
    name: _propTypes.default.string,

    /** Function returns text or html */
    formatter: _propTypes.default.func,

    /** custom function to download file. */
    downLoadFile: _propTypes.default.func
  })),

  /** String text */
  title: _propTypes.default.string,

  /** String text */
  subtitle: _propTypes.default.string,

  /** String text */
  createdBy: _propTypes.default.string,

  /** String text */
  createdDate: _propTypes.default.string,

  /** String text or html */
  log: _propTypes.default.string,

  /** Bootstrap column size. default col-sm-3 */
  leftColumnSize: _propTypes.default.string,

  /** Bootstrap column size. default col-sm-9 */
  rightColumnSize: _propTypes.default.string,

  /** String text */
  attachmentTitle: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node])
};
var _default = HistoryLog;
exports.default = _default;